// ---------------------------------------------------------------------------
// Text (paragraph) Renderer
// ---------------------------------------------------------------------------
// Foundational primitive — publishes the editor `Text` block as one or more
// <p> elements. Distinct from `text-block`, which is a richer container with
// its own heading and max-width controls.

import { registerRenderer } from "../registry.js";
import type { RenderContext } from "../types.js";
import { attr, text } from "../escape.js";

type TextAlign = "left" | "center" | "right";

interface TextProps {
  content?: string;
  align?: TextAlign | string;
}

const VALID_ALIGNMENTS: ReadonlySet<TextAlign> = new Set([
  "left",
  "center",
  "right",
]);

function resolveAlignment(value: unknown): TextAlign {
  if (typeof value === "string" && VALID_ALIGNMENTS.has(value as TextAlign)) {
    return value as TextAlign;
  }
  return "left";
}

function render(props: Record<string, unknown>, _ctx: RenderContext): string {
  const p = props as TextProps;

  const content = typeof p.content === "string" ? p.content : "";
  if (!content.trim()) {
    return "<!-- text missing content -->";
  }

  const alignment = resolveAlignment(p.align);

  const paragraphs = content
    .split(/\n\n+/)
    .map((para) => para.trim())
    .filter((para) => para.length > 0)
    .map((para) => `  <p class="ease-text__paragraph">${text(para)}</p>`)
    .join("\n");

  return `<section class="ease-section ease-text" style="text-align: ${attr(alignment)};">
${paragraphs}
</section>`;
}

registerRenderer("text", { render });
